/* web/app/components/layout/main/header/navbar-mobile/side/navbar-mobile-side.scss */
/*# sourceMappingURL=navbar-mobile-side.css.map */
